module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-900.e22a661e.woff2";